import { ReactElement, RefObject } from 'react';
import { Box, Text, Container, Flex, Grid, GridItem } from '@chakra-ui/react';

import Heading from 'components/atoms/heading/index';
import Button from 'components/atoms/button/index';
import Card from 'components/molecules/card';
import BrandLogo from 'components/atoms/images/brandLogo/index';
import { IconType } from 'lib/@types';

export interface GeekCommentsProps {
  companiesTitle: string;
  companiesLogo: Array<{
    src: string;
    alt: string;
    w: number[] | Record<string, number>;
    h: number[] | Record<string, number>;
  }>;
  geekiesTitle: string | ReactElement;
  geekiesComments: Array<{
    image: {
      src: string;
      alt: string;
    };
    name: string;
    position: string;
    comment: string;
  }>;
  geekCommentsButton: string;
  geekCommentsButtonIcon: IconType;
  formRef?: RefObject<HTMLDivElement>;
}

const GeekComments = ({
  companiesTitle,
  companiesLogo,
  geekiesTitle,
  geekiesComments,
  geekCommentsButton,
  geekCommentsButtonIcon,
  formRef,
}: GeekCommentsProps): ReactElement => (
  <Box bg='background.900' w='100%' py='20' px={[4, 4, 0, 0]}>
    <Text fontSize='16px' color='text.200' textAlign='center' mb={[8, 8, 0, 0]}>
      {companiesTitle}
    </Text>

    <Container maxW='container.xl'>
      <Flex
        wrap='wrap'
        justify='center'
        alignItems='center'
        mb={[32, 32, 8, 8]}
      >
        {companiesLogo.map((companyLogo) => (
          <Box
            p={[2, 2, 8, 8]}
            key={companyLogo.alt}
            data-testid='company-logo'
          >
            <BrandLogo
              src={companyLogo.src}
              alt={companyLogo.alt}
              w={companyLogo.w}
              h={companyLogo.h}
            />
          </Box>
        ))}
      </Flex>

      <Heading format='h2' textAlign='center' mb={[8, 8, 16, 16]}>
        {geekiesTitle}
      </Heading>

      <Grid
        templateColumns={[null, 'repeat(1, 1fr)', null, 'repeat(3, 1fr)']}
        gap={8}
        mb={8}
      >
        {geekiesComments.map((geekComment) => (
          <GridItem key={geekComment.name} data-testid='geek-comment'>
            <Card
              leftImageSrc={geekComment.image.src}
              leftImageAlt={geekComment.image.alt}
              title={geekComment.name}
              subtitle={geekComment.position}
            >
              {geekComment.comment}
            </Card>
          </GridItem>
        ))}
      </Grid>

      <Flex justify='center'>
        <Button
          w='240px'
          size='xl'
          rightIcon={geekCommentsButtonIcon}
          onClick={() => formRef?.current?.scrollIntoView()}
        >
          {geekCommentsButton}
        </Button>
      </Flex>
    </Container>
  </Box>
);

export default GeekComments;
